export enum MediaType {
  IMAGE = 0,
  VIDEO = 1,
  FILE = 2,
  EMBED_LINK = 3,
  OTHER = 4
}

export enum EMediaDefaultId {
  NONE = -1
}

export enum EMediaError {
  MEDIA_LINK_REQUIRED = 'Media link is required'
}

export enum EMediaDefaultName {
  NO_NAME = 'No name'
}

export enum EListMediaType {
  ALL = 'All types',
  PHOTO = 'Photos',
  VIDEO = 'Video & Audio',
  DOCUMENT = 'Document',
  EMBED_LINK = 'Embed link',
  UNKNOWN = 'Unknown'
}

export enum EMediaTitle {
  MEDIA_GALLERY = 'Media Gallery',
  THUMBNAIL = 'THUMBNAIL'
}

export enum EMediaThumbnail {
  PHOTO = 'Photo',
  PDF = 'PDF',
  WORD = 'Word',
  CSV = 'CSV',
  EXCEL = 'Excel',
  UNKNOWN = 'Unknown',
  PPT = 'PowerPoint',
  VIDEO = 'Video',
  AUDIO = 'Audio',
  COMPRESSED = 'Compressed',
  EMBED = 'Embed'
}

export const SOCIAL_EMBED_HOSTS: Record<'YOUTUBE' | 'INSTAGRAM' | 'FACEBOOK' | 'TIKTOK' | 'TWITTER', string[]> = {
  YOUTUBE: ['youtube.com', 'youtu.be'],
  INSTAGRAM: ['instagram.com'],
  FACEBOOK: ['facebook.com', 'm.facebook.com', 'fb.watch'],
  TIKTOK: ['tiktok.com'],
  TWITTER: ['twitter.com', 'x.com']
}

export const EMBED_URLS = {
  YOUTUBE: {
    BASE: 'https://www.youtube.com/embed/'
  },
  INSTAGRAM: {
    BASE: 'https://www.instagram.com/p/',
    EMBED_SUFFIX: '/embed/'
  },
  TIKTOK: {
    BASE: 'https://www.tiktok.com/embed/v2/',
    SHORT_DOMAINS: ['vm.tiktok.com', 'vt.tiktok.com']
  },
  FACEBOOK: {
    BASE: 'https://www.facebook.com/plugins/post.php',
    VIDEO_BASE: 'https://www.facebook.com/plugins/video.php',
    MIN_WIDTH: 180,
    MAX_WIDTH: 500,
    DEFAULT_WIDTH: 500,
    DEFAULT_HEIGHT: 500
  },
  TWITTER: {
    BASE: 'https://platform.twitter.com/embed/Tweet.html',
    DEFAULT_PARAMS: {
      dnt: 'false',
      embedId: 'twitter-widget-0',
      frame: 'false',
      hideCard: 'false',
      hideThread: 'false',
      lang: 'en',
      theme: 'light',
      widgetsVersion: '2615f7e52b7e0%3A1702314776716',
      width: '550px'
    }
  }
}

export const MOBILE_BREAKPOINT = 768
export const WWW_PREFIX = 'www.'
export const WWW_PREFIX_LENGTH = 4;